import React, { Component } from 'react'
import { css } from 'aphrodite';
import { AppStyles } from '../../styles/AppTheme';
import { SEStyles } from './SEStyles';
import { Tooltip } from '@material-ui/core';
import { CustomSEStyles } from '../../styles/CustomStyles';
import { AppButton } from '../../common/components/AppButton';
import { AppConfig } from '../../AppConfig';
import { TableComponent } from '../../common/components/TableComponent';
import { Helper } from '../../common/helpers/Helper';

export class SubEntityListLite extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className={css(Styles.container)}>
        <div className={css(Styles.heading)}>
          <div className={css(Styles.headingContent)}>
            <h2 className={css(Styles.stepFormTitle)}>{this.props.title}</h2>
            {!this.props.noAdd &&
              <AppButton
                onClick={() => this.props.openModalForAdd()}
                buttonText={this.props.buttonTitle || 'Add'}
                buttonStyle={Styles.editButton}
                buttonTextStyle={Styles.buttonText} />}
          </div>
        </div>
        <div className={css(Styles.content)}>
          {this.props.items && this.props.items.length > 0 ? <TableComponent
            compact
            tableHeadersMap={this.props.tableHeadersMap}
            items={this.props.items}
            noTableHead={this.props.noTableHead}
            onActions={this.props.subEntityActions ? this.props.subEntityActions : this.onActions.bind(this)}
          />
            :
            <div className={css(Styles.emptyContainer)}>
              <p>{this.props.emptyText || Helper.getString('emptyMsg')}</p>
            </div>
          }
        </div>
      </div>
    )
  }

  onActions = (current) => {
    const actions = []
    if (!this.props.noPreview) {
      actions.push(
        <Tooltip title='Preview' placement='top-start' key={current.id + 'preview'}>
          <span className={css(AppStyles.entityTableLinkIcon, Styles.actionIcon)}>
            <img
              alt={Helper.getString('tileIcon')}
              className={css(Styles.tileIcon)}
              width={18}
              height={18}
              onClick={() => this.props.openModalForPreview(current)}
              src={require('../../assets/images/monitor.svg')} />
          </span>
        </Tooltip>
      )
    }
    if (!this.props.noEdit) {
      actions.push(
        <Tooltip title='Edit' placement='top-start' key={current.id + 'editTT'}>
          <span className={css(AppStyles.entityTableLinkIcon, Styles.actionIcon)}>
            <img
              alt={Helper.getString('tileIcon')}
              className={css(Styles.tileIcon)}
              width={18}
              height={18}
              onClick={() => this.props.openModalForEdit(current)}
              src={require('../../assets/images/edit.svg')} />
          </span>
        </Tooltip>
      )
    }
    if (!this.props.noDelete) {
      actions.push(
        <Tooltip title='Delete' placement='top-start' key={current.id + 'deleteTT'}>
          <span className={css(AppStyles.entityTableLinkIcon, Styles.actionIcon)}>
            <img
              alt={Helper.getString('tileIcon')}
              className={css(Styles.tileIcon)}
              width={18}
              height={18}
              onClick={() => this.props.openModalForDelete(current)}
              src={require('../../assets/images/trash.svg')} />
          </span>
        </Tooltip>
      )
    }
    return actions
  }
}

const Styles = AppConfig.CUSTOM_STYLE ? CustomSEStyles : SEStyles



// WEBPACK FOOTER //
// ./src/components/advertiser/SubEntityListLite.js